import type { SxProps, Theme } from "@mui/material/styles";
import type { TooltipProps } from "@mui/material/Tooltip";
import type { AccountFeatureType } from "constants/accountFeatures";
import ACCOUNT_FEATURE from "enums/ACCOUNT_FEATURE";
import colors from "theme/base/colors";

/** Canonical upsell copy when an account or project lacks a catalog feature. */
export const DISABLED_FEATURE = {
  [ACCOUNT_FEATURE.AI_INSIGHTS]:
    "Talk to your account manager to enable AI Insights",
  [ACCOUNT_FEATURE.PERSONAS]: "Talk to your account manager to enable Personas",
  [ACCOUNT_FEATURE.PROJECT_SEARCH]:
    "Talk to your account manager to enable project searches",
  [ACCOUNT_FEATURE.ACCOUNT_SEARCH]:
    "Talk to your account manager to enable Account Search",
} as const satisfies Record<AccountFeatureType, string>;

export const toolTipUpsell: SxProps<Theme> = {
  bgcolor: colors.grey[800],
  color: colors.white.main,
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 1.4,
  maxWidth: 240,
  px: 1.25,
  py: 0.75,
};

export const disabledFeatureTooltipSlotProps: TooltipProps["slotProps"] = {
  tooltip: { sx: toolTipUpsell },
};

export function disabledFeatureUpsellMessage(
  featureName: string,
): string | undefined {
  return DISABLED_FEATURE[featureName as AccountFeatureType];
}

export function accountFeatureTooltipTitle(
  featureName: string,
  enabled: boolean,
  enabledLabel: string,
): string {
  if (!enabled) {
    return disabledFeatureUpsellMessage(featureName) ?? enabledLabel;
  }
  return enabledLabel;
}
